import { ActionType } from "../interfaces/api/actionType";

export const GetCalendlyEvents: ActionType = {
  FAILURE: "GET_CALENDLY_EVENTS_FAILURE",
  REQUEST: "GET_CALENDLY_EVENTS_REQUEST",
  SUCCESS: "GET_CALENDLY_EVENTS_SUCCESS",
};
